import React, { FC, useState } from 'react'

import { IDecksChanges, IDecksList, IDecksListRows, ITableRows } from './types'
import { compareNumbers, stringCompare, transformToNumberAndCompare } from '../../utils/sorters'
import { onlyNumbers } from '../../utils/formValidation'
import List from '../../components/List'

export function useDataTransform(data: IDecksListRows[]) {
  if(!data || data.length === 0) return []
  const transformedRows = data.map((row) => {
    let obj = {}
    row.contentGames.map((wager) => {
      obj = {...obj, [wager.form]: {gameId: wager.gameId, enabled: wager.enabled}} 
    })
    return {...row.itemContentLocationDTO, ...obj}
  })
  return transformedRows
}

export function getInputBackgroundColor( locationId: number, gameId: number, changed: IDecksChanges[]) {
  
  const isChanged = changed.find((wager) => wager.gameId === gameId && wager.locationId === locationId)

  return {color: isChanged ? 'red': 'transparent'}
}

export function getTagBackGroundColor( hasOlderVersions: boolean, isDisabled: boolean): {color: string, style: React.CSSProperties} {
  const color = isDisabled ? 'gray' : hasOlderVersions ? 'orange' : ''
  const border = isDisabled ? 'none' : hasOlderVersions ? '' : 'none'
  return {color, style: {border}}
}

export function getColConfig(key: string, headers: string[]) {
  let config: {
    key: string, 
    width: number, 
    fixed: boolean | 'left', 
    sorter: (a: ITableRows, b: ITableRows) => number 
  } = {
    key, 
    width: 200, 
    fixed: false, 
    sorter: (a, b) => {
      return stringCompare(
        `${a[key as keyof ITableRows]}`,
        `${b[key as keyof ITableRows]}`
      )
    }
  }

  switch(key) {
    case 'charityName': 
      return {...config, fixed: true, key: 'Charity'}
    case 'locationName': 
      return {...config, fixed: true, key: 'Location'}
    case 'countVersion': 
      const headerVersion = headers.find((header) => header.includes('Version'))
      return {...config, width: 100, key: headerVersion}
    case 'countOldVersion': 
      return {
        ...config, 
        width: 100, 
        key: 'Older Versions', 
        sorter: (a: ITableRows, b: ITableRows) => transformToNumberAndCompare(`${a[key as keyof ITableRows]}`, `${b[key as keyof ITableRows]}`)
      }
    default:
      return config
  }
}

export type DecksChanges = {
  status: 'SUCCESS' | 'FAILED';
  location: string;
  form: string;
  action: 'ENABLE' | 'DISABLE';
  reason?: string;
}

export type ChangesModalContentProps = {
  changes: DecksChanges[];
};

export const ChangesModalContent: FC<ChangesModalContentProps> = ({changes}) => {
  return (
    <List
      scroll={{y: 500}}
      pagination={false}
      columns={[
        {
          title: 'Status' ,
          dataIndex: 'status',
          render: (val: string) => val
        },
        {
          title: 'Location' ,
          dataIndex: 'location',
          render: (val: string) => val
        },
        {
          title: 'Form' ,
          dataIndex: 'form',
          render: (val: string) => val
        },
        {
          title: 'Action' ,
          dataIndex: 'action',
          render: (val: string) => val
        },
        {
          title: 'Reason' ,
          dataIndex: 'reason',
          render: (val: string) => val
        },
      ]}
      rows={changes} 
    />
  )
}
    